import "./WordCard.css";

const getFontSize = (text) => {
  if (!text) return '24px';
  const len = text.length;
  const longestWord = Math.max(...text.split(/\s+/).map(w => w.length));
  if (longestWord > 14) return '14px';
  if (len <= 20) return '24px';
  if (len <= 50) return '18px';
  if (len <= 100) return '14px';
  return '11px';
};

const WordCard = ({word}) => {
  return (
    <div className="lavender-container">
      <p className="word" style={{ fontSize: getFontSize(word) }}>{word}</p>
    </div>
  )
};

export { WordCard };